/* eslint-disable */
export default {
  eula: 'Endbenutzer-Lizenzvereinbarung',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
